import { useCallback, useMemo } from 'react'
import { useDropzone } from 'react-dropzone'

const baseStyle = {
  minHeight: '100px',
  width: '100%',
  padding: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '2px dashed #c6c6c6',
  backgroundColor: '#f4f4f4',
  overflow: 'hidden',
  borderRadius: '8px',
  outline: 'none',
  cursor: 'pointer',
  transition: 'border .24s ease, background .24s ease',
}

const focusedStyle = {
  border: '2px dashed var(--primary-color)',
}

const acceptStyle = {
  border: '2px dashed var(--primary-color)',
  backgroundColor: '#ECFDF2',
}

const rejectStyle = {
  border: '2px dashed #ff1744',
  backgroundColor: '#FFD9D0',
}

const CustomDropzone = ({
  isMultiple,
  onSubmit,
  loading = false,
  acceptedFileTypes = { 'text/csv': ['.csv'] }, // Default to CSV
}) => {
  const onDrop = useCallback((acceptedFiles) => onSubmit(isMultiple ? acceptedFiles : acceptedFiles[0]), [isMultiple, onSubmit])

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } = useDropzone({
    accept: acceptedFileTypes,
    multiple: isMultiple,
    onDrop,
    disabled: loading,
  })

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
      ...(loading ? { backgroundColor: '#f6f6f6', color: '#999' } : {}),
    }),
    [isFocused, isDragAccept, isDragReject, loading]
  )

  // Collect allowed extensions in one array
  const allowedExts = useMemo(() => {
    return Object.values(acceptedFileTypes).flat()
  }, [acceptedFileTypes])

  return (
    <div {...getRootProps({ style })}>
      <input {...getInputProps()} />

      <div className='d-flex gap-2 align-items-center justify-content-center'>
        {isDragReject ? (
          <h4>Some files may be rejected</h4>
        ) : (
          <div>
            <h4>
              Drag and drop or <span className='text-success'>select files</span>
            </h4>
            <p className='m-0 text-secondary fw-bold'>{allowedExts.join(', ')} only.</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomDropzone
